import * as React from 'react';
import {RouteComponentProps} from "react-router";
import {Link} from "react-router-dom";
import {lazyInject} from "@athena-portal/core";
import {authorize} from "@athena-portal/components";
import {
    FalconNavigatorHeader,
    ICustomerPortalService,
    productHelper,
    ProductsEnum,
    Quote,
    resourcesHelper,
    Types
} from "@falcon/services";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import {PluginTemplates} from "../../../../utils/PluginTemplates";

interface IProps extends RouteComponentProps<{}> {}

interface IState {
    quotes?: Quote[];
    annualMotorQuotes: Quote[];
    subscriptionMotorQuotes: Quote[];
    rentersQuotes: Quote[];
    annualHomeQuotes: Quote[];
}

@authorize
export class ViewOrGetQuotesPage extends React.Component<IProps, IState> {

    private pluginTemplates = new PluginTemplates();
    private readonly QUOTES_PAGE: string = "/dashboard/quotes";
    private readonly ANNUAL_QUOTES_PAGE: string = "/dashboard/annualQuotes";
    private readonly HOME_INSURANCE_QUOTES_PAGE: string = "/dashboard/HomeInsuranceQuotes";

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: Readonly<IProps>) {
        super(props);
        this.state = {
            annualMotorQuotes: [],
            subscriptionMotorQuotes: [],
            rentersQuotes: [],
            annualHomeQuotes: []
        }
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Get a new quote or view saved quotes");
        this.fetchQuotesAndPolicies();
    }

    private fetchQuotesAndPolicies = () => {
        this.customerPortalService.getQuotes().subscribe((quotes: Quote[]) => {
            this.setState({
                annualMotorQuotes: this.getQuotesByProduct(quotes, ProductsEnum.WOLF_MOTOR),
                subscriptionMotorQuotes: this.getQuotesByProduct(quotes, ProductsEnum.MOTOR),
                rentersQuotes: this.getQuotesByProduct(quotes, ProductsEnum.RENTERS),
                annualHomeQuotes: this.getQuotesByProduct(quotes, ProductsEnum.HOME),
                quotes
            });
        });
    }

    public render() {
        const annualMotorEnabled: boolean = process.env.REACT_APP_ANNUAL_MOTOR_ENABLED ? JSON.parse(process.env.REACT_APP_ANNUAL_MOTOR_ENABLED) : true;
        const annualHomeEnabled: boolean = process.env.REACT_APP_ANNUAL_HOME_ENABLED ? JSON.parse(process.env.REACT_APP_ANNUAL_HOME_ENABLED) : false;
        const subscriptionMotorProductEnabled: boolean = process.env.REACT_APP_MOTOR_PRODUCT_ENABLED ? JSON.parse(process.env.REACT_APP_MOTOR_PRODUCT_ENABLED) : false;
        const rentersProductEnabled: boolean = process.env.REACT_APP_RENTERS_PRODUCT_ENABLED ? JSON.parse(process.env.REACT_APP_RENTERS_PRODUCT_ENABLED) : false;
            return (
                <React.Fragment>
                    <FalconHeader/>
                            <div className="plugin view-or-get-quotes-page">
                                <FalconNavigatorHeader back="/dashboard" title="Get a new quote or view saved quotes"/>
                                <div className="view-or-get-quotes-content">
                                    {annualMotorEnabled && this.renderAnnualMotorTile()}
                                    {(this.state.subscriptionMotorQuotes.length > 0 || subscriptionMotorProductEnabled) && <div className="panel bg-white overflow-hidden p-0 mx-3 font-weight-extra-light mb-4">
                                        <div className="inner-content pb-4">
                                            <div className="quote-panel-title mt-4">Monthly subscription car cover</div>
                                            <img className="vehicle-icon" src={`/${resourcesHelper.THEME}/img/wolf-car-icon.png`} alt="Vehicle icon"/>
                                            <div className="quote-panel-description text-center px-3">
                                                <p className="mb-0">Flexible, simple monthly payments.</p>
                                                <p className="mb-0">Cover will keep rolling until you cancel.</p>
                                                <p className="mb-0">No fees or monthly interest</p>
                                            </div>
                                            {subscriptionMotorProductEnabled && <Link
                                                to={productHelper.getNewBusinessUrl(ProductsEnum.MOTOR)}
                                                className="inner-content buttonLink"
                                                id="viewSavedSubscriptionCarQuotes">
                                                <button type="button" className="btn btn-primary btn-add">
                                                    Subscription car quote
                                                </button>
                                            </Link>}
                                            <div className="quote-panel-view-quotes">
                                                {
                                                    this.state.subscriptionMotorQuotes.length > 0
                                                        ?
                                                        <Link
                                                            to={this.QUOTES_PAGE}
                                                            onClick={() => this.setShowOnly(ProductsEnum.MOTOR)}>
                                                            View your saved quotes
                                                        </Link>
                                                        :<p>
                                                            You don't have any Car subscription saved quotes
                                                        </p>
                                                }
                                            </div>
                                        </div>
                                    </div>}

                                    {(this.state.rentersQuotes.length > 0 || rentersProductEnabled) && <div className="panel bg-white overflow-hidden p-0 mx-3 font-weight-extra-light mb-4">
                                    <div className="inner-content pb-4">
                                        <div className="quote-panel-title mt-4">Monthly subscription renters cover</div>
                                        <img className="vehicle-icon" src="/img/renters-cover-icon.png" alt="Renters icon"/>
                                        <div className="quote-panel-descriptiontext-center px-3">
                                            <p className="mb-0">Flexible simple monthly payments</p>
                                            <p className="mb-0">Contents cover for renters with no cancellation or admin fees</p>
                                        </div>
                                        {rentersProductEnabled && <Link
                                                to={productHelper.getNewBusinessUrl(ProductsEnum.RENTERS)}
                                                className="inner-content buttonLink"
                                                id="viewSavedRentersQuotes">
                                                <button type="button" className="btn btn-primary btn-add">
                                                    Subscription renters quote
                                                </button>
                                            </Link>}
                                            <div className="quote-panel-view-quotes">
                                                {
                                                    this.state.rentersQuotes.length > 0
                                                        ?
                                                        <Link
                                                            to={this.QUOTES_PAGE}
                                                            className="inner-content text-wrap"
                                                            id="viewSavedRentersQuotes"
                                                            onClick={() => this.setShowOnly(ProductsEnum.RENTERS)}
                                                        >
                                                            View your saved quotes
                                                        </Link>
                                                        : <p className="px-3 text-center">You don't have any Renters saved quotes</p>
                                                }
                                            </div>
                                        </div>
                                    </div>}
                                    {annualHomeEnabled && this.renderAnnualHomeTile()}
                                </div>
                                {this.renderRenewalDateCapturePanel()}
                                {this.pluginTemplates.renderBackLink("Back", false, "/dashboard")}
                            </div>
                    <FalconFooter/>
                </React.Fragment>
            )
    }

    private renderAnnualMotorTile = () => {
        const annualMotorQuoteCount: number = this.state.annualMotorQuotes.length;
        const hasMotorQuotes: boolean = annualMotorQuoteCount > 0;
        const linkToNbJourney = `${productHelper.getNewBusinessUrl(ProductsEnum.WOLF_MOTOR)}/dashboardEntryPage`;
        return (<div className="panel bg-white overflow-hidden p-0 mx-3 font-weight-extra-light mb-4">
            <div className="inner-content pb-4">
                {this.renderQuoteCountWording(annualMotorQuoteCount)}
                {resourcesHelper.THEME === "Flow" &&
                    <div className="quote-panel-title mt-4">Comprehensive car insurance</div>}
                <div className="d-flex">
                    <div className="product-section-home-logo d-flex">
                        <img className="home-icon"
                             src={`/${resourcesHelper.THEME}/img/wolf-car-icon.png`}
                             alt="Vehicle icon"/>
                    </div>
                    <div className="product-section-defaqto-logo d-flex col-sm">
                        <img className="defaqto-logo-sm"
                             src="/img/DefaqtoLogo.svg"
                             alt="Defaqto logo"
                             aria-label="Defaqto logo"/>
                    </div>
                </div>

                {resourcesHelper.THEME === "Allianz" &&
                    <div className="quote-panel-title mt-4">Comprehensive car insurance</div>}
                <div className="quote-panel-description text-center px-3">
                    {PluginTemplates.getNewQuoteWording[ProductsEnum.WOLF_MOTOR]}
                </div>
                <Link
                    to={hasMotorQuotes ? this.ANNUAL_QUOTES_PAGE : linkToNbJourney}
                    className="inner-content buttonLink"
                    id="viewSavedSubscriptionCarQuotes">
                    <button type="button" className="btn btn-primary btn-add">
                        {hasMotorQuotes ? "View your car quote" : "Car quote"}
                    </button>
                </Link>
                <div className="quote-panel-view-quotes">
                    {
                        hasMotorQuotes
                            ? <Link
                                to={linkToNbJourney}>
                                Get a new car quote
                            </Link>
                            : <p className="mb-0">
                                You don't have any car quotes
                            </p>
                    }
                </div>
            </div>
        </div>)
    }

    private renderAnnualHomeTile = () => {
        const annualHomeQuoteCount: number = this.state.annualHomeQuotes.length;
        const hasHomeQuotes: boolean = annualHomeQuoteCount > 0;
        const linkToNbJourney = `${productHelper.getNewBusinessUrl(ProductsEnum.HOME)}/dashboardEntryPage`;

        return (
            <div className="panel bg-white overflow-hidden p-0 mx-3 font-weight-extra-light mb-4">
                <div className="inner-content pb-4">
                    {this.renderQuoteCountWording(annualHomeQuoteCount)}
                    {resourcesHelper.THEME === "Flow" &&
                        <div className="quote-panel-title mt-4">Buildings &amp; contents home insurance</div>}

                    <div className="d-flex">
                        <div className="product-section-home-logo d-flex">
                            <img className="home-icon"
                                 src={`/${resourcesHelper.THEME}/img/home-icon.png`}
                                 alt="Home icon"/>
                        </div>
                        <div className="product-section-defaqto-logo d-flex col-sm">
                            <img className="defaqto-logo-sm"
                                 src="/img/DefaqtoLogoHome.svg"
                                 alt="Home Defaqto logo"
                                 aria-label="Defaqto logo home"/>
                        </div>
                    </div>

                    {resourcesHelper.THEME === "Allianz" &&
                        <div className="quote-panel-title mt-4">Buildings and contents home insurance</div>}

                    <div className="quote-panel-description text-center px-3">
                        {PluginTemplates.getNewQuoteWording[ProductsEnum.HOME]}
                    </div>

                    <Link
                        to={hasHomeQuotes ? this.HOME_INSURANCE_QUOTES_PAGE : linkToNbJourney}
                        className="inner-content buttonLink"
                        id="viewSavedSubscriptionHomeQuotes">
                        <button type="button" className="btn btn-primary btn-add">
                            {hasHomeQuotes ? "View your home quote" : "Home quote"}
                        </button>
                    </Link>

                    <div className="quote-panel-view-quotes">
                        {
                            hasHomeQuotes
                                ? <Link to={linkToNbJourney}>
                                    Get a new home quote
                                </Link>
                                : <p className="mb-0">You don’t have any home quotes</p>
                        }
                    </div>
                </div>
            </div>
        )
    }

    private renderQuoteCountWording = (quoteCount: number) => {
        const quoteText: string = quoteCount === 1 ? " quote" : " quotes";
        return (
            <div className="valid-quote-counter">
                <p>You have <span className="muli-bold-16">{quoteCount}</span> {quoteText}</p>
            </div>
        );
    }

    private renderRenewalDateCapturePanel = () => {
        return (
            <div className="banner banner-content">
                <img src={`/${resourcesHelper.THEME}/img/Flow-info.svg`} alt="Blue info icon"/>
                <div className="banner-text">
                    <span className="font-weight-bold">Not the right time for a quote?</span>
                    <p className="mt-3">If you have a policy with another insurer, just let us know when it's due for
                        renewal.</p>
                    <p className="mt-3">We'll get in touch before your renewal date so you can get a quote from us and
                        compare it with
                        your current provider.{' '}
                        <a href={"https://cloud.comms.allianz.co.uk/RenewalDateCapture"} id="renewal-date-capture-link">Let
                            us know</a>
                    </p>
                </div>
            </div>
        )
    }

    private getQuotesByProduct(quotes: Quote[], product: string): Quote[] {
        return quotes?.filter((quote) => quote?.product === product);
    }

    private setShowOnly(productName: string): void {
        sessionStorage.setItem("SHOW_ONLY", productName);
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/quotesPage/ViewOrGetQuotesPage.tsx